import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/hooks';
import ErrorMessage from './ErrorMessage';
const Genders = {
    MALE: "男性",
    FEMALE: "女性",
};
const GenderSelect = ({ value, errors, onInput }) => {
    const hasError = Object.entries(errors ?? {}).filter(error => error[0] === "gender").length;
    const handleSelect = useCallback((evt) => {
        onInput("gender", evt.currentTarget.value);
    }, []);
    return (_jsxs("div", Object.assign({ className: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u6027\u5225" }), void 0),
            _jsxs("select", Object.assign({ className: `input ${hasError > 0 ? 'is-danger' : ''}`, value: value.gender, onInput: handleSelect }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                    Object.entries(Genders).map(gender => (_jsx("option", Object.assign({ value: gender[0] }, { children: gender[1] }), void 0)))] }), void 0),
            _jsx(ErrorMessage, { field: "prefectureCode", errors: errors }, void 0)] }), void 0));
};
export default GenderSelect;
